// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore

const get = (obj, path, defaultValue = undefined) => {
  if (!path) return path;
  const travel = regexp =>
    String.prototype.split
    .call(path, regexp)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

const each = function (collection, iterator) {
  if (Array.isArray(collection)) {
    for (var i = 0; i < collection.length; i++)
      iterator(collection[i], i, collection);
  } else if (collection instanceof Object) {
    for (var key in collection)
      iterator(collection[key], key, collection);
  } else if (collection === null) {
    return collection;
  }
};

const defaults = function (obj) {
   each(arguments, function (extend) {
     for (var key in extend) {
       if (!(key in obj)) obj[key] = extend[key];
     }
   });
   return obj;
};

const throttle = function (func, wait, options = {leading: false, trailing: true}) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};
  var later = function () {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  var throttled = function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    }
    else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  }
  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };
  return throttled;
};

const fromPairs = function (arr) {
  return arr.reduce(function (accumulator, value) {
    accumulator[value[0]] = value[1];
    return accumulator;
  }, {})
}

const isEmpty = (value) => {
  if (value == null) {
    return true;
  }
  if (typeof value == 'string') {
    value = value.trim();
  }
  if (Array.isArray(value) || typeof value == 'string' || typeof value.splice == 'function') {
    return !value.length;
  }
  return Object.getOwnPropertyNames(value).length === 0;
}

const isString = function (str) {
  if (str && typeof str.valueOf() === "string") {
    return true
  }
  return false
}

export const camelCase = function (str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (match, chr) {
    return chr.toUpperCase();
  });
}

const isFunction = function (func) {
  if (func && typeof func === "function") {
    return true
  }
  return false
}

const head = function (arr) {
  const [header, ...tail] = arr;
  return header;
}

const some = function (arr) {
  let result = false;
  arr.forEach(element => {
    if (element) result = true;
  });
  return result;
}

const truncate = function (str, num) {
  let omission = '...';
  if (str.length <= num) {
    return str;
  }
  let end = num - omission.length;
  if (end < 1) return omission;
  return str.slice(0, end) + omission;
}

const isNumber = function (value) {
  return typeof value === 'number' && Number.isFinite(value);
}

const isObject = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

const toNumber = (value) => {
  if (typeof value == 'number') {
    return value;
  }

  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  } else {
    const re = /^\d*(\.\d+)?$/;
    if (!value.match(re)) return NaN;
    return parseInt(value);
  }
}

const flatten = function (arr) {
  return arr.reduce((a, b) => a.concat(b), []);
}

function isExist (element) {
  if (element) {
    return true;
  }
  return false;
}

const every = function (collection) {
  return collection.every(isExist);
};

const extend = (target, ...sources) => {
  const length = sources.length;
  if (length < 1 || target == null) return target;
  for (let i = 0; i < length; i++) {
    const source = sources[i];

    for (const key in source) {
      target[key] = source[key];
    }
  }
  return target;
};

const width = (el) => {
  let w = parseFloat(getComputedStyle(el, null).width.replace("px", ""));
  if (isNaN(w)) return el.getBoundingClientRect().width;
  return w;
}

export const height = (el) => {
  let h = parseFloat(getComputedStyle(el, null).height.replace("px", ""));
  if (isNaN(h)) return el.getBoundingClientRect().height;
  return h;
}

const ready = (fn) => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

const outerHeight = (el) => {
  var height = el.offsetHeight;
  var style = getComputedStyle(el);
  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return height;
}

export const isHidden = (el) => {
  return (el.offsetParent === null);
}

const getUrlParams = (param) => {
  return Object.keys(param)
    .map(key => key + "=" + param[key])
    .join("&");
}

const htmlToElement = (html) => {
  var template = document.createElement('template');
  html = html.trim(); // Never return a text node of whitespace as the result
  template.innerHTML = html;
  return template.firstChild || template.content.firstChild;
}

const htmlToElements = (html) => {
  var template = document.createElement('template');
  template.innerHTML = html;
  return template.childNodes || template.content.childNodes;
}


export default {
  get,
  defaults,
  throttle,
  fromPairs,
  isEmpty,
  isString,
  camelCase,
  isFunction,
  head,
  some,
  truncate,
  isNumber,
  toNumber,
  flatten,
  every,
  extend,
  width,
  height,
  ready,
  outerHeight,
  isHidden,
  getUrlParams,
  htmlToElement,
  htmlToElements
}
